<script setup>
</script>

<template>
  <div class="header-links-divider" />
  <div>
    <a
      href="https://www.scania.com/jp/"
      target="_blank"
      class="header-links-item"
    >{{ $i18n('headerLinkScaniaJapan') }}</a>
  </div>
  <div class="header-links-divider" />
  <div>
    <a
      href="https://www.scania.com/jp/ja/home/products/trucks/prime-ready"
      target="_blank"
      class="header-links-item"
    >{{ $i18n('headerLinkPrimeReady') }}</a>
  </div>
  <div class="header-links-divider" />
  <div>
    <a
      href="https://www.scania.com/jp/ja/home/about-scania/Scania_Japan/contact-us.html"
      target="_blank"
      class="header-links-item"
    >{{ $i18n('headerLinkScaniaJapanContact') }}</a>
  </div>
</template>

<style scoped>
  .header-links-divider {
    background-color: var(--sdds-white);
    width: 1px;
    min-width: 1px;
    max-width: 1px;
    height: 25%;
  }
  .header-links-item {
    color: var(--sdds-white);
    text-decoration: none;
    border: 0;
  }
  .header-links-item:hover {
    text-decoration: underline;
  }
</style>
